import type { ScoringRules, UserAnswer, Question } from '@examflow/core';

/**
 * DELE 评分规则
 * DELE 使用 0-100 分制，每个部分 25 分
 */
export const deleScoringRules: ScoringRules = {
  totalScore: 100,
  passingScore: 60,
  calculateScore: (answers: UserAnswer[], questions: Question[]): number => {
    if (questions.length === 0) return 0;

    const correctCount = answers.filter((a) => a.isCorrect).length;
    const accuracy = correctCount / questions.length;

    const score = Math.round(accuracy * 100);

    return Math.min(100, Math.max(0, score));
  },
};
